import { render, staticRenderFns } from "./SubmitClaim.vue?vue&type=template&id=51ccfbd6"
import script from "./SubmitClaim.vue?vue&type=script&lang=js"
export * from "./SubmitClaim.vue?vue&type=script&lang=js"
import style0 from "./SubmitClaim.vue?vue&type=style&index=0&id=51ccfbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports